import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import orderBy from 'lodash/orderBy'

import { SearchSelect, Checkbox } from '../../../input'
import { CustomDatePicker } from '../../../datepicker'
import { FONTS } from '../../../../constants'
import { months } from '../../types'

export const CompanyInfoSecondCol = props => {
  const {
    emp,
    users,
    handleInput,
  } = props

  const money_adjust_month = months.find(m => m.value === emp.money_adjust_month) || null
  const referral = users.find(u => u._id === emp.referral) || null

  return (
    <FormWrapper>
      <FormGroup>
        <LabelCol>
          <Label>Adjust Salary Month</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='money_adjust_month'
            placeholder='Select Adjust Salary Month'
            value={ money_adjust_month }
            options={ months }
            onChange={ e => handleInput(e, 'money_adjust_month') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Probation Complete</Label>
        </LabelCol>
        <InputCol>
          <CustomDatePicker
            showYearDropdown
            showMonthDropdown
            autoComplete='off'
            name='probation_complete_date'
            dateFormat='DD/MM/YYYY'
            selected={ emp.probation_complete_date ? moment(emp.probation_complete_date) : null }
            onChange={ e => handleInput(e, 'probation_complete_date') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelRoleCol>
          <Label>Adjust Salary After Probation</Label>
        </LabelRoleCol>
        <InputCol>
          <Checkbox
            id='adjust_after_complete_create'
            name='adjust_after_complete'
            checked={ emp.adjust_after_complete }
            onChange={ e => handleInput(e, 'adjust_after_complete') }
          />
        </InputCol>
      </FormGroup>
      <FormGroup>
        <LabelCol>
          <Label>Referral Program by</Label>
        </LabelCol>
        <InputCol>
          <SearchSelect
            name='referral'
            placeholder='Select Referral Program by'
            value={ referral }
            options={ orderBy(users, 'label', 'asc') }
            onChange={ e => handleInput(e, 'referral') }
          />
        </InputCol>
      </FormGroup>
    </FormWrapper>
  )
}

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const LabelRoleCol = styled.div`
    display: flex;
    flex: 3;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/create-form/company-info/second-column.js